"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FamillyAccount = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var FamillyAccount = function FamillyAccount(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.6,
    cx: 16,
    cy: 16,
    r: 16,
    fill: "url(#FamillyAccount_svg__FamillyAccount_svg__paint0_linear_18154_91340)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 12.8a2.4 2.4 0 11-4.8 0 2.4 2.4 0 014.8 0zM12.8 16a4 4 0 00-4 4v.8a.8.8 0 00.8.8H16a.8.8 0 00.8-.8V20c0-.9-.298-1.732-.8-2.4a3.994 3.994 0 00-3.2-1.6zm5.6 4v.8c0 .28-.048.55-.136.8H22.4a.8.8 0 00.8-.8V20a4 4 0 00-6-3.465A5.576 5.576 0 0118.4 20zm.8-4.8a2.4 2.4 0 100-4.8 2.4 2.4 0 000 4.8z",
    fill: "#fff",
    fillOpacity: 0.7
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "FamillyAccount_svg__FamillyAccount_svg__paint0_linear_18154_91340",
    x1: 0,
    y1: 32,
    x2: 33.868,
    y2: 29.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4D600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5BB784"
  }))));
};

exports.FamillyAccount = FamillyAccount;
var _default = FamillyAccount;
exports.default = _default;